import React from "react";
import { FiArrowLeft, FiShoppingCart, FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function PharmacyBrandDetails() {
  const navigate = useNavigate();

  // Static brand data
  const brand = {
    image: "https://www.webshakers.in/wp-content/themes/dp/img/clients/2.png",
    company: "CIPLA LTD",
    description: "List of Products from the Selected Company",
    products: [
      {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "8901117157330 Okacet Tab",
        mrp: "₹20.00",
        ptr: "-",
        status: "Stock Out",
      },
      {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "9pm Eye Drops",
        mrp: "₹610.52",
        ptr: "₹465.16",
        status: "Stock Out",
      },
      {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "Aceclo+Cpm Tav Tab",
        mrp: "₹67.60",
        ptr: "-",
        status: "Stock Out",
      },
      {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "Acetate Rb Tabs",
        mrp: "-",
        ptr: "-",
        status: "Stock Out",
      },
      {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "Aci Free (Jeera) 5gm",
        mrp: "₹11.72",
        ptr: "₹4.70",
        status: "Stock Out",
      },
       {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "Dolo 650mg Tablet",
        mrp: "₹13.72",
        ptr: "₹4.70",
        status: "Stock Out",
      },
       {
        image: "https://i.pinimg.com/736x/55/cb/a9/55cba9714cb8e099214694b6ed998bac.jpg",
        name: "Derma Soothe Cream",
        mrp: "₹11.72",
        ptr: "₹4.70",
        status: "Stock Out",
      },
    ],
  };

  return (
    <div className="p-4 bg-[#f8f8fb] min-h-screen font-sans text-gray-800">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <img
            src={brand.image}
            alt={brand.company}
            className="w-20 h-20 object-contain rounded-md"
          />
          <div>
            <h1 className="text-2xl font-bold">{brand.company}</h1>
            <p className="text-gray-500 text-sm">{brand.description}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium transition"
          >
            <FiArrowLeft className="text-lg" /> Go Back
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiShoppingCart className="text-lg" /> Add to Cart
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiEye className="text-lg" /> View Cart
          </button>
        </div>
      </div>

      {/* Product Table */}
      <div className="bg-white rounded-xl shadow-md overflow-x-auto">
  {/* Scrollable Table Wrapper */}
  <div className="max-h-[400px] overflow-y-auto">  
    <table className="w-full text-sm border-collapse">

       <thead className="bg-green-50 text-gray-700 border-b sticky top-0 z-10 shadow-sm">

        <tr>
            <th className="py-3 pl-2 pr-3 text-left font-semibold w-8">
            <input type="checkbox" style={{ accentColor: "#16a34a" }} />
            </th>
            <th className="py-3 pl-2 pr-4 text-left font-semibold">IMAGE</th>


              <th className="py-3 px-4 text-left font-semibold">PRODUCT</th>
              <th className="py-3 px-4 text-left font-semibold">CATEGORY</th>
              <th className="py-3 px-4 text-left font-semibold">MRP</th>
              <th className="py-3 px-4 text-left font-semibold">PTR</th>
              <th className="py-3 px-4 text-left font-semibold">MARGIN</th>
              <th className="py-3 px-4 text-left font-semibold">MY STATUS</th>
              <th className="py-3 px-4 text-left font-semibold">MIN | MAX</th>
              <th className="py-3 px-4 text-left font-semibold">STK</th>
            </tr>
          </thead>
          <tbody>
            {brand.products.map((p, i) => (
              <tr key={i} className="border-t hover:bg-green-50 transition">
                {/* Checkbox */}
                <td className="py-2 px-2">
                  <input type="checkbox" style={{ accentColor: "#16a34a" }} />
                </td>

               {/* Image under IMAGE column */}
                <td className="py-2 px-2">
                <img
                    src={p.image}
                    alt={p.name}
                    className="w-10 h-10 object-contain rounded-md border"
                />
                </td>

                {/* Product Name under PRODUCT column */}
                <td className="py-2 px-2 font-medium text-gray-800">
                {p.name}
                </td>


                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 font-medium">{p.mrp}</td>
                <td className="py-2 px-2 font-medium">{p.ptr}</td>
                <td className="py-2 px-2 text-gray-500">-</td>

                {/* Status */}
                <td className="py-2 px-2">
                  <span className="bg-red-100 text-red-600 text-xs px-3 py-1 rounded-md font-medium">
                    {p.status}
                  </span>
                </td>

                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 text-gray-500">-</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex flex-wrap justify-between items-center py-3 px-4 text-xs text-gray-500 bg-gray-50 border-t gap-2">
          <div>
            To Focus – <span className="font-medium">Up or Down Key</span> | To
            Select – <span className="font-medium">Space</span>
          </div>
          <div className="flex items-center gap-2">
            <button className="text-gray-500 hover:text-green-600">&lt;</button>
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-md font-medium">
              1
            </span>
            <button className="text-gray-500 hover:text-green-600">&gt;</button>
            <span>20 / page</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PharmacyBrandDetails;
